import { z } from "zod/v4";

export const ShippingCountryFilterSchema = z.object({
  allow: z.string().array().optional(),
  exclude: z.string().array().optional(),
});

export type ShippingCountryFilter = z.infer<typeof ShippingCountryFilterSchema>;

export const ShippingRateValueFilterSchema = z.object({
  type: z.literal("amount"),
  amount: z.number().optional(),
});

export type ShippingRateValueFilter = z.infer<
  typeof ShippingRateValueFilterSchema
>;

export const ShippingRateNameOperatorList = [
  "is",
  "contains",
  "isNot",
  "doesNotContain",
  "startsWith",
  "doesNotStartWith",
] as const;

export type ShippingRateNameOperator =
  (typeof ShippingRateNameOperatorList)[number];

export const ShippingRateNameRuleSchema = z.object({
  id: z.string(),
  operator: z.enum(ShippingRateNameOperatorList),
  name: z.string(),
});

export type ShippingRateNameRule = z.infer<typeof ShippingRateNameRuleSchema>;

export const ShippingRateNameFilterSchema = z.object({
  type: z.literal("name"),
  rules: z.array(ShippingRateNameRuleSchema),
});

export type ShippingRateNameFilter = z.infer<
  typeof ShippingRateNameFilterSchema
>;

export const ShippingRateFilterSchema = z.union([
  ShippingRateValueFilterSchema,
  ShippingRateNameFilterSchema,
]);

export type ShippingRateFilter = z.infer<typeof ShippingRateFilterSchema>;

export const ShippingDiscountDiscountTypeList = [
  "percentage",
  "dollar",
] as const;

export type ShippingDiscountDiscountType =
  (typeof ShippingDiscountDiscountTypeList)[number];

export const ShippingDiscountDtoSchema = z.object({
  id: z.uuid(),
  discountType: z.enum(ShippingDiscountDiscountTypeList),
  unitDiscount: z.number(),
  rateFilter: ShippingRateFilterSchema.nullable(),
  countryFilter: ShippingCountryFilterSchema.nullable(),
  discountLabel: z.string().nullable(),
});

export type ShippingDiscountDto = z.infer<typeof ShippingDiscountDtoSchema>;

export const CreateShippingDiscountDtoSchema = ShippingDiscountDtoSchema.extend(
  {
    offerId: z.uuid().optional(),
  }
);

export type CreateShippingDiscountDto = z.infer<
  typeof CreateShippingDiscountDtoSchema
>;

// app only builds free shipping
export const ExternalWriteShippingDiscountDtoSchema =
  ShippingDiscountDtoSchema.extend({
    discountType: z.literal("percentage", {
      error:
        "Only percentage shipping discounts are supported (free shipping is discountType 'percentage' with unitDiscount 100). Dollar-amount shipping discounts are not supported.",
    }),
  });

export type ExternalWriteShippingDiscountDto = z.infer<
  typeof ExternalWriteShippingDiscountDtoSchema
>;
